import React from 'react';
import { 
  LayoutDashboard, 
  Package, 
  Package2, 
  ShoppingCart, 
  CreditCard, 
  User,
  FileText,
  Building2,
  ChevronLeft,
  ChevronRight,
  LogOut
} from 'lucide-react';
import './Sidebar.css';

const Sidebar = ({ activeTab, setActiveTab, collapsed, setCollapsed, onLogout }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'products', label: 'Products', icon: Package },
    { id: 'inventory', label: 'Inventory', icon: Package2 },
    { id: 'orders', label: 'Orders', icon: ShoppingCart },
    { id: 'kyc', label: 'KYC', icon: FileText },
    { id: 'payouts', label: 'Payouts', icon: CreditCard },
    { id: 'profile', label: 'Profile', icon: User },
  ];

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : 'open'}`}>
      <div className="sidebar-header">
        <div className="logo">
          <div className="logo-icon">V</div>
          {!collapsed && <span className="logo-text">Vendor Portal</span>}
        </div>
        <button 
          className="collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>
      
      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
              onClick={() => {
                setActiveTab(item.id);
                if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                  setCollapsed(true);
                }
              }}
            >
              <Icon size={20} />
              {!collapsed && <span>{item.label}</span>}
            </button>
          );
        })}
      </nav>
      
      <div className="sidebar-footer">
        <button
          className="logout-btn"
          onClick={() => {
            onLogout();
            if (typeof window !== 'undefined' && window.innerWidth <= 768) {
              setCollapsed(true);
            }
          }}
        >
          <LogOut size={20} />
          {!collapsed && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
